// .env のエンティティ
// process.env で直接取得するのではなく、このエンティティを介して取得するようにします。

const Env = {
  // システム設定
  SYSTEM_MODE: process.env.REACT_APP_SYSTEM_MODE ?? 'none',
  SYSTEM_TITLE: process.env.REACT_APP_SYSTEM_TITLE ?? '未設定',

  // Azureサービス接続設定
  AZURE_BLOB_STORAGE_ACCOUNT_URI: process.env.REACT_APP_AZURE_BLOB_STORAGE_ACCOUNT_URI ?? '',
  AZURE_APPLICATION_INSIGHTS_CONNECTION_STRING: process.env.REACT_APP_AZURE_APPLICATION_INSIGHTS_CONNECTION_STRING ?? '',

  // OIDC接続設定
  OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID ?? '',
  OIDC_SERVICE_URI: process.env.REACT_APP_OIDC_SERVICE_URI ?? '',
  OIDC_LOGIN_REDIRECT_PAGE: process.env.REACT_APP_OIDC_LOGIN_REDIRECT_PAGE ?? '',
  OIDC_LOGOUT_REDIRECT_PAGE: process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_PAGE ?? '',

  // WebAPI接続設定
  WEBAPI_URI: process.env.REACT_APP_WEBAPI_URI,
  WEBAPI_TIMEOUT_MS: Number(process.env.REACT_APP_WEBAPI_TIMEOUT_MS),
  WEBAPI_RETRY: Number(process.env.REACT_APP_WEBAPI_RETRY),

  // システム管理者連絡先
  ADMIN_EMAIL: process.env.REACT_APP_ADMIN_EMAIL ?? '未設定',
  ADMIN_TEL: process.env.REACT_APP_ADMIN_TEL ?? '未設定',

  // Tableau設定
  TABLEAU_URL: process.env.REACT_APP_TABLEAU_URL ?? '',
  TABLEAU_SUPPLIER_URL: process.env.REACT_APP_TABLEAU_SUPPLIER_URL ?? ''
}
export default Env
